import { RouteConfig } from 'vue-router';
import UsersRoutes from '@/router/UsersRoutes';
import SubscriptionRoutes from '@/router/SubscriptionRoutes';
import MerchantRoutes from '@/router/MerchantRoutes';
import NetworkRoutes from '@/router/NetworkRoutes';
import ServiceRoutes from '@/router/ServiceRoutes';
import SettingsRoutes from '@/router/SettingsRoutes';
import TranslationRoutes from '@/router/TranslationRoutes';
import { Dashboard, AppMain } from '@/components';
import { Loading, Message } from 'element-ui';
import store from '@/store';

const routes: RouteConfig[] = [
  {
    path: '/admin',
    component: AppMain,
    children: [
      {
        path: '',
        alias: 'dashboard',
        name: 'dashboard',
        components: {
          default: Dashboard
        },
        meta: {
          pageTitle: 'Dashboard'
        }
      },
      ...UsersRoutes,
      ...SubscriptionRoutes,
      ...MerchantRoutes,
      ...NetworkRoutes,
      ...ServiceRoutes,
      ...SettingsRoutes,
      ...TranslationRoutes
    ],
    beforeEnter: async (to, from, next) => {
      // @ts-ignore
      if (!store.state.AppMod.adminInitialized) {
        const loading = Loading.service({
          lock: true,
          text: 'Initializing Admin...',
          background: 'rgba(0, 0, 0, 0.9)'
        });
        try {
          await store.dispatch('initAdminState');
        } catch (e) {
          Message.error(
            'Failed to initial admin, please try reload this page.'
          );
        } finally {
          loading.close();
        }
      }
      next();
    }
  }
];

export default routes;
